import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../../utils/createNotification';

export interface UpdateBuyerIsVdrAvailableArg {
    engagementId: number;
    buyerId: number;
    isVdrAvailable: boolean;
}

export const UpdateBuyerIsVdrAvailable = createAsyncThunk(
    'timelines/updateBuyerIsVdrAvailable',
    async (arg: UpdateBuyerIsVdrAvailableArg, dispatch: any) => {
        const axios = dispatch.getState().core.axios;

        try {
            const response = await axios.put(
                `/api/Marketplace/Engagements/${arg.engagementId}/IsVdrAvailable`,
                {
                    buyerId: arg.buyerId,
                    isVdrAvailable: arg.isVdrAvailable,
                }
            );

            if (response.status !== 200) {
                throw new Error('Failed to update buyer VDR availability');
            }

            return {
                buyerId: arg.buyerId,
                isVdrAvailable: arg.isVdrAvailable,
            };
        } catch (error) {
            createNotification(
                'An error occurred while updating buyer VDR availability.',
                'error'
            );
            throw error;
        }
    }
);

